export function getImgPath(imageName) {
  var images = require.context("../assets/images/", true, /^\.\/.*$/);
  return images("./" + imageName);
}
